import React from "react";
import { Link } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { BsEmojiFrown } from "react-icons/bs";
import { useSelector } from "react-redux";

const NotFound = () => {
  const { translations, dir } = useSelector((state) => state.language);
  return (
    <div className="min-h-screen bg-[#0f172a] flex items-center justify-center px-4">
      <div className="bg-[#1e293b] rounded-xl p-10 max-w-lg w-full text-center shadow-lg">
        <div className="flex justify-center mb-6">
          <div className="bg-[#0f172a] rounded-full p-4">
            <BsEmojiFrown className="text-white text-5xl" />
          </div>
        </div>
        <h1 className="text-white text-3xl font-bold mb-4">
          {translations.notefoundpage.pagenotfound}
        </h1>
        <p className="text-gray-400 mb-6">
          {translations.notefoundpage.Thehelpfullinks}
        </p>
        <Link
          to="/"
          className="inline-flex no-underline items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-medium px-6 py-2 rounded-md transition"
        >
          <FaArrowLeft />
          {translations.notefoundpage.backtoHome}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
